import axios from "axios";
import {
  GetCifCupsRequestBody,
  GetCifCupsResponse,
} from "../../models/cupsCifSelector/cupsCifSelector.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const getCifCups = async (
  requestBody: GetCifCupsRequestBody,
  token: string
): Promise<GetCifCupsResponse[]> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CIFS_CUPS, requestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

export { getCifCups };
